/**
 * Human-readable status copy for family screens.
 * Inputs: schema enum strings. Outputs: sentence-case labels. Never invent facts.
 */

const STATUS: Record<string, string> = {
  booked_owner_reported: "Booked, as we recorded it",
  booked_chat_agreement: "Agreed in chat",
  booked_chat_confirmation: "Confirmed in chat",
  booked_supplier_confirmed: "Confirmed by the supplier",
  idea: "Idea only",
  planned: "Planned",
  cancelled: "Cancelled",
  unpaid_owner_reported: "Unpaid, as we recorded it",
  unknown: "Not on the booking yet",
  unpaid: "Unpaid",
  partial: "Part paid",
  paid: "Paid",
  expected_date: "Expected date",
  tentative_date: "Around this date",
  pay_at_property: "Pay at the property",
  confirmed_deadline: "Deadline",
  provisional: "Still to confirm",
  provisional_generic_webpage: "Time still to confirm",
  owner_confirmed: "Time confirmed",
  proposed_not_explicitly_confirmed: "Proposed split, not yet confirmed",
  confirmed_50_50: "Confirmed 50/50",
  split_to_confirm: "Split to confirm",
  assigned: "Assigned",
  owner_confirmed_split: "Split confirmed",
  planning_estimate: "Planning estimate",
  inferred_from_hotel_dates_not_visible_in_chat: "Inferred from hotel dates",
  imported_schedule: "Imported schedule",
  imported_schedule_not_airline_reverified: "Imported schedule, not airline-verified",
  availability_window_not_appointment: "Check-in window, not an appointment",
  hotel_reservation: "Hotel",
  excursion: "Excursion",
  transfer_package: "Transfer",
  transfer: "Transfer",
  grab_bolt: "Grab or Bolt",
  taxi: "Taxi",
  arranged_driver: "Arranged driver",
  after_arrival: "After the flight lands",
  when_ready: "When you're ready",
  fixed: "Fixed time",
  flexible: "Flexible",
  booked: "Booked",
  flight: "Flight",
  other: "Other",
  free_time: "Free time",
  stay_window: "Stay",
  accommodation: "Hotel",
  booking: "Booking",
  place: "Place",
  event: "Plan",
  note: "Note",
  contact: "Contact",
  reference: "Reference",
  ok: "Available",
  stale: "Cached",
  unavailable: "Not configured",
  error: "Could not update",
  not_yet_in_range: "Not in the travel window yet",
  rate_limited: "Paused to stay inside the budget",
  disabled: "Off",
  published_listing_not_surveyed_entrance: "Published listing location, not a surveyed entrance",
  osm_property_listing: "OpenStreetMap listing location",
  osm_building_on_named_soi: "Mapped building on the named soi",
};

export const UNKNOWN_FACT = "Not on the booking yet";

export function humanStatus(value?: string | null): string {
  if (!value) return "";
  if (STATUS[value]) return STATUS[value];
  if (value.includes("provisional")) return "Still to confirm";
  return value.replaceAll("_", " ");
}

export function searchKindLabel(kind: string): string {
  return STATUS[kind] ?? kind;
}

export function weatherPhrase(code: number | undefined): string | null {
  if (code === undefined || Number.isNaN(code)) return null;
  if (code === 0) return "Clear";
  if (code <= 3) return "Partly cloudy";
  if (code <= 48) return "Fog";
  if (code <= 57) return "Drizzle";
  if (code <= 67) return "Rain";
  if (code <= 77) return "Snow";
  if (code <= 82) return "Showers";
  if (code <= 99) return "Thunder";
  return null;
}
